// extracted by mini-css-extract-plugin
module.exports = {"recipe":"Recipes_recipe__2eNRm","image":"Recipes_image__2dIl5","list":"Recipes_list__3apei","calories":"Recipes_calories__30D7M"};